<template>
  <div class="zmanim-list__container">
    <component
      v-for="item in items"
      :key="item.key"
      :is="componentForItem(item)"
      :class="classForItem(item)"
      v-bind="item"
    />
  </div>
</template>

<script>
import ZmanimList from '@/lib/zmanimList'
import { brooklyn } from '@/lib/locations'
import ZmanimListHeader from './ZmanimListHeader'
import ZmanimListEntry from './ZmanimListEntry'

export default {
  name: 'ZmanimList',
  components: {
    ZmanimListHeader,
    ZmanimListEntry
  },
  props: {
    location: {
      type: Object,
      default: () => brooklyn
    }
  },
  computed: {
    zmanim () {
      const location = this.location
      const zmanimList = new ZmanimList(location)
      return zmanimList
    },
    items () {
      return this.zmanim.items
    }
  },
  methods: {
    classForItem (item) {
      return item.entryType === 'header'
        ? 'zmanim-list__header'
        : 'zmanim-list__item'
    },
    componentForItem (item) {
      return item.entryType === 'header' ? ZmanimListHeader : ZmanimListEntry
    }
  }
}
</script>

<style scoped>
.zmanim-list__container {
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: 100%;
  width: 100%;
  overflow: auto;
  flex-grow: 1;
  margin-right: 0;
  background: #ff8511;
}
</style>
